import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="shrink-0 bg-[#0a3d91] dark:bg-[#0a2d6e] border-t border-[#0a2d6e] dark:border-blue-900 py-3 px-6 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <div className="w-5 h-5 rounded bg-white/20 flex items-center justify-center">
          <span className="text-white text-[10px] font-black">AG</span>
        </div>
        <span className="text-white/90 text-xs font-semibold tracking-wide">AutoGain Insight Systems</span>
      </div>
      <p className="text-white/60 text-xs">
        &copy; {new Date().getFullYear()} AutoGain Insight Systems LLC. All rights reserved.
      </p>
      <div className="text-white/40 text-xs hidden sm:block">
        Living Reliability Platform
      </div>
    </footer>
  );
};

export default Footer;
